import clsx from "clsx"
import {forwardRef} from "react"

const HorizontalTranslateContainer = forwardRef(({ children, translateX }, ref) => {
    const translateClass = `translate-x-[${translateX}px]`;
    return (
        <div ref={ref} className={clsx("absolute h-full", translateClass)}>            
            {children}
        </div>
    );
})
HorizontalTranslateContainer.displayName = "HorizontalTranslateContainer"

export default HorizontalTranslateContainer; 